// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__vDBPO","footerLogo":"Logo_footerLogo__3QbJz","headerLogo":"Logo_headerLogo__40hXm"};